import { Status, withProps } from '@mna/react'


export default withProps(props => {
  return props

})(() =>
  <div className="article-width">
    <h1>Something went wrong</h1>
  </div>
)
